<h2 mat-dialog-title>
    Globale Metadaten {{ data?.id ? 'bearbeiten' : 'anlegen' }}
</h2>

<div class="pixl-form">
    <mat-dialog-content [formGroup]="form" class="grid">

        <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Beschreibung</mat-label>
            <input matInput formControlName="description" />
        </mat-form-field>

        @if (!data?.id) {
            <mat-checkbox formControlName="isConsumerField">
                {{ 'is_consumer_field' | transloco }}
            </mat-checkbox>
        }

        <div class="full-width mb-3">
            <h4 class="mt-0 mb-3" style="font-weight:normal;">Feld-Konfiguration</h4>

            <div formArrayName="fieldConfig">
                @for (fc of fieldConfig.controls; track fc; let i = $index) {
                    <div [formGroupName]="i" class="border-area">

                        <div class="option-row">

                            <mat-form-field>
                                <mat-label>Label</mat-label>
                                <input matInput formControlName="label" required />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Name</mat-label>
                                <input matInput formControlName="name" required />
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Typ</mat-label>
                                <mat-select formControlName="datatype"
                                            (selectionChange)="onDatatypeChange(fc)">
                                    @for (type of globalMetaDataTypes$ | async; track type) {
                                        <mat-option [value]="type.name">
                                            {{ type.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <button mat-icon-button color="warn" (click)="removeFieldConfig(i)">
                                <mat-icon>delete</mat-icon>
                            </button>

                        </div>

                        @if (getFieldType(fc) === 'Selection' || getFieldType(fc) === 'SingleSelection') {
                            <pixl-form-dialog-global-metadata-selection [parentGroup]="fc" class="full-width"></pixl-form-dialog-global-metadata-selection>
                        }

                        @if (getFieldType(fc) === 'DropDown') {
                            <pixl-form-dialog-global-metadata-dropdown [parentGroup]="fc" class="full-width"></pixl-form-dialog-global-metadata-dropdown>
                        }

                        @if (getFieldType(fc) === 'IconSelection') {
                            <pixl-form-dialog-global-metadata-icon-selection [parentGroup]="fc" class="full-width"></pixl-form-dialog-global-metadata-icon-selection>
                        }

                        @if (getFieldType(fc) === 'PairedSelection') {
                            <pixl-form-dialog-global-metadata-paired-selection [parentGroup]="fc" class="full-width"></pixl-form-dialog-global-metadata-paired-selection>
                        }

                    </div>
                }
            </div>

            <button mat-raised-button
                    color="primary"
                    class="mt-3"
                    (click)="addFieldConfig()">
                Feld hinzufügen
            </button>

        </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">
            Speichern
        </button>
    </mat-dialog-actions>
</div>